import {
  MapLayerControls,
  ParentProps,
  DispatchProps,
  OwnProps,
  mapStateToProps
} from '../../core/components/Map/MapLayerControls'
import {connect} from 'react-redux'
import {appLayersDispatcher} from '../../dispatchers/appLayersDispatcher'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'

class AppMapLayersControl extends MapLayerControls {}

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appLayersDispatcher,
  ...appMapDispatcher
})(AppMapLayersControl)
